import React from 'react'
import gql from 'graphql-tag'
import Heading from 'components/shared/Heading'
import Query from 'components/shared/Query'
import CustomerRef from './CustomerRef'
import EstateSellers from './EstateSellers'
import OrdersDetails from './OrdersDetails'
import './index.scss'

export const estateInfoQuery = gql`
  query EstateInfoQuery($estateId: ID!) {
    estate(id: $estateId) {
      id
      customerRef
      estateSellers {
        id
        type
        name
        email
        phone
      }
      additionalInfo
      doorbell
      orders {
        edges {
          node {
            id
            invisoRef
            customerComment
          }
        }
      }
    }
  }
`

const EstateInfo = ({ match }) => {
  const estateId = match.params.estateId
  return (
    <div className="estate-info">
      <Heading level={2}>Boliginformasjon</Heading>
      <Query
        inlineLoading
        inlineError
        query={estateInfoQuery}
        variables={{ estateId }}
      >
        {({ getData }) => {
          const customerRef = getData('estate.customerRef')
          const estateSellers = getData('estate.estateSellers')
          const additionalInfo = getData('estate.additionalInfo')
          const doorbell = getData('estate.doorbell')
          const orders = getData('estate.orders')

          return (
            <>
              <CustomerRef customerRef={customerRef} estateId={estateId} />
              <EstateSellers
                estateSellers={estateSellers}
                estateId={estateId}
              />
              <OrdersDetails
                orders={
                  orders && orders.edges
                    ? orders.edges.map((edge) => edge.node)
                    : []
                }
                additionalInfo={additionalInfo}
                doorbell={doorbell}
              />
            </>
          )
        }}
      </Query>
    </div>
  )
}

export default EstateInfo
